import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { connectToStores } from 'fluxible-addons-react';
import classnames from 'classnames';
import Icon from '../../../../libraries/utils/components/icon';
import Tooltip from '../../../../libraries/utils/components/tooltip';
import Droplist from '../../../../libraries/utils/components/droplist';

class SearchUserDropdown extends Component {
  static propTypes = {
    onSearchTypeChange: PropTypes.func.isRequired,
    searchUserBy: PropTypes.oneOf(['email', 'username', 'text']),
    className: PropTypes.string,
    isSuperAdmin: PropTypes.bool,
    isTextOption: PropTypes.bool
  };

  static defaultProps = {
    onSearchTypeChange: () => {},
    searchUserBy: 'username'
  };

  static displayName = 'SearchUserDropdown';

  onChangeSearchType(type) {
    this.props.onSearchTypeChange(type);
    this.refs.dropdown.hide();
  }

  @autobind
  openDropdown() {
    this.refs.dropdown.toggle();
  }

  openContextMenu() {
    const { isTextOption } = this.props;

    var items = [
      <span onClick={this.onChangeSearchType.bind(this, 'username')}>Username</span>,
      <span onClick={this.onChangeSearchType.bind(this, 'email')}>Email</span>
    ];

    const textItem = (
      <span onClick={this.onChangeSearchType.bind(this, 'text')} className="feature-dot">
        Text
      </span>
    );

    if (isTextOption) {
      items.push(textItem);
    }

    return <Droplist items={items} />;
  }

  render() {
    let { searchUserBy } = this.props;
    let className = classnames('search-user-dropdown', this.props.className);
    return (
      <span className={className} onClick={this.openDropdown}>
        <span className="search-type">{searchUserBy}</span>
        <div className="tooltip-wrapper" ref="handler">
          <Tooltip
            className="dropdown tooltip-general"
            caret
            ref="dropdown"
            alignElement={() => this.refs.handler}
            hasScreenBoundries
          >
            {this.openContextMenu()}
          </Tooltip>
        </div>
      </span>
    );
  }
}

export default SearchUserDropdown;
